import styled from "styled-components";
import { Button } from "antd";
import { BASE_COLORS, BORDER_RADIUS, FONT_FAMILY, FONT_SIZE_PX, FONT_WEIGHT, media, TEXT_ALIGN } from "config/theme/constants";

export const SubmitButton = styled(Button)`
  font-size: ${FONT_SIZE_PX.lg};
  font-weight: ${FONT_WEIGHT.normal};
  width: 100%;
  margin-top: 1rem;
`;

export const InitialInfo = styled.span`
  font-weight: ${FONT_WEIGHT.normal};
  font-size: ${FONT_SIZE_PX.xs};
  font-family: ${FONT_FAMILY.main};
  letter-spacing: 0px;
  color: ${BASE_COLORS.black};
  opacity: 0.5;
`;

export const FormTitle = styled.div`
  color: var(--primary-color);

  @media only screen and ${media.xs} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }

  @media only screen and ${media.md} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }

  @media only screen and ${media.xl} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }
`;
export const FormWrapper = styled.div`
  padding: 0 2.5rem 2.5rem 2.5rem;
  width: 51.75rem;
  overflow: hidden;
  background-color: ${BASE_COLORS.white};
  border-radius: ${BORDER_RADIUS};

  .logo-container {
    text-align: ${TEXT_ALIGN.center};
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .password-field {
    width: 100%;
  }

  .password-validator-container {
    display: flex;
  }

  @media only screen and ${media.xs} {
    padding: 20px;
    width: 17rem;
    max-height: calc(100vh - 3rem);
  }

  @media only screen and ${media.md} {
    padding: 0 1.5rem 1.5rem 1.5rem;
    width: 18rem;
    max-height: calc(100vh - 3rem);
  }
`;
